import { render, staticRenderFns } from "./ClientSearchV2.vue?vue&type=template&id=0fb91368&scoped=true&"
import script from "./ClientSearchV2.vue?vue&type=script&lang=js&"
export * from "./ClientSearchV2.vue?vue&type=script&lang=js&"
import style0 from "./ClientSearchV2.vue?vue&type=style&index=0&id=0fb91368&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb91368",
  null
  
)

export default component.exports